import { apiClient } from "@/lib/api-client";
import type {
  AdminContainerListResponse,
  AdminContainerFilters,
  AdminContainerDetail,
  AdminContainerEditData,
  AnalyzeResult,
} from "@/types/api/admin-containers";

export async function getAdminContainers(
  filters?: AdminContainerFilters
): Promise<AdminContainerListResponse> {
  const params: Record<string, string | number | boolean> = {};
  if (filters?.page) params.page = filters.page;
  if (filters?.page_size) params.page_size = filters.page_size;
  if (filters?.sort_by) params.sort_by = filters.sort_by;
  if (filters?.sort_order) params.sort_order = filters.sort_order;
  if (filters?.company_id) params.company_id = filters.company_id;
  if (filters?.vip_max !== undefined) params.vip_max = filters.vip_max;
  if (filters?.risk_min !== undefined) params.risk_min = filters.risk_min;
  if (filters?.search) params.search = filters.search;
  if (filters?.status && filters.status.length > 0) params.status = filters.status.join(",");
  if (filters?.include_archived) params.include_archived = filters.include_archived;
  return apiClient<AdminContainerListResponse>("/admin/containers", {
    method: "GET",
    params,
  });
}

export async function getAdminContainer(
  id: string
): Promise<AdminContainerDetail> {
  return apiClient<AdminContainerDetail>(`/admin/containers/${id}`, {
    method: "GET",
  });
}

export async function updateAdminContainer(
  id: string,
  data: AdminContainerEditData
): Promise<{
  fields_updated: string[];
  field_changes: Record<string, { old: string | null; new: string | null }>;
}> {
  return apiClient(`/admin/containers/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: { "Content-Type": "application/json" },
  });
}

export async function analyzeContainer(
  id: string
): Promise<AnalyzeResult> {
  return apiClient<AnalyzeResult>(`/admin/containers/${id}/analyze`, {
    method: "POST",
  });
}
